function PageNotFound(){
    return (
        <div className="">
            404 | Pagina niet gevonden
        </div>
    )
}

export default PageNotFound